<template>
    <div class="home-info-raii">
        <content-subheader class="home-content" text="Российская ассоциация искусственного интеллекта (РАИИ)"/>
        <content-about-text class="home-content home-info-raii-text" text="Общероссийская общественная организация «Российская ассоциация искусственного интеллекта» является общественным объединением, основанным на членстве лиц, профессиональная деятельность которых связана с теоретическими и прикладными исследованиями и разработками в области искусственного интеллекта."></content-about-text>
    </div>
</template>
<script>
import ContentSubheader from '@/components/content/ContentSubheader.vue'
import ContentAboutText from '@/components/content/ContentAboutText.vue'


export default {
    name: 'HomeInfoRaii',
    components: {
        ContentSubheader,
        ContentAboutText
    }
}
</script>